import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, Button, Form, Spinner, Container, Badge } from "react-bootstrap";
import { api } from "../../services/api";
import Swal from "sweetalert2";

export default function ConfirmarGozoMobile() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [loading, setLoading] = useState(true);
    const [dadosGozo, setDadosGozo] = useState(null);
    const [senha, setSenha] = useState("");
    const [processando, setProcessando] = useState(false);
    const [concluido, setConcluido] = useState(false);

    useEffect(() => {
        if (token) {
            api.get(`/rh/ferias/gozo/detalhes-token/${token}`)
                .then(res => {
                    let dataObj = res.data;
                    if (Array.isArray(dataObj) && dataObj.length > 0) {
                        dataObj = dataObj[0];
                    }
                    // LOG PARA DIAGNÓSTICO: Verifique as chaves no F12 do navegador
                    console.log("JSON recebido do Delphi:", dataObj);
                    setDadosGozo(dataObj);
                })
                .catch(err => {
                    console.error("Erro ao buscar token:", err);
                    Swal.fire("Erro", "Link inválido ou expirado.", "error");
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
            Swal.fire("Atenção", "Token de confirmação ausente na URL.", "warning");
        }
    }, [token]);

    // Busca exaustiva por todas as variações possíveis de nomes de chaves
    const nomeColaborador = dadosGozo?.NOME ?? dadosGozo?.nome ?? "";
    const matriculaColaborador = dadosGozo?.MATRICULA ?? dadosGozo?.matricula ?? "";

    const periodoInicio = dadosGozo?.PERIODO_INICIO ?? dadosGozo?.periodo_inicio ?? 
                          dadosGozo?.INICIOPERAQUIS ?? dadosGozo?.inicioperaquis ?? "";

    const periodoFim = dadosGozo?.PERIODO_FIM ?? dadosGozo?.periodo_fim ?? 
                        dadosGozo?.FIMPERAQUIS ?? dadosGozo?.fimperaquis ?? "";

    const dataInicio = dadosGozo?.DATA_INICIO ?? dadosGozo?.data_inicio ?? "";
    const dataFim = dadosGozo?.DATA_FIM ?? dadosGozo?.data_fim ?? "";
    const diasGozados = dadosGozo?.DIAS_GOZADOS ?? dadosGozo?.dias_gozados ?? 0;

    const handleAssinarFerias = async (e) => {
        e.preventDefault();
        if (!matriculaColaborador) {
            Swal.fire("Erro", "Dados da solicitação não encontrados.", "error");
            return;
        }

        setProcessando(true);
        try {
            const resAuth = await api.post("/usuario/consultausuario/web", {
                usuario: String(matriculaColaborador),
                senha: senha,
                versao: "1.2"
            });

            if (resAuth.data?.SUCESSO !== "S") {
                Swal.fire("Senha Incorreta", "A senha digitada está incorreta.", "error");
                setProcessando(false);
                return;
            }

            await api.post("/rh/ferias/gozo/confirmar", { token });

            setConcluido(true);
            Swal.fire("Férias Confirmadas!", "Sua assinatura digital foi registrada com sucesso.", "success");

        } catch (err) {
            const msg = err.response?.data?.erro || "Erro ao processar assinatura.";
            Swal.fire("Erro", msg, "error");
        } finally {
            setProcessando(false);
        }
    };

    if (loading) {
        return (
            <Container className="text-center pt-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2 text-muted">Carregando detalhes das férias...</div>
            </Container>
        );
    }

    if (concluido) {
        return (
            <Container className="pt-5" style={{ maxWidth: '450px' }}>
                <Card className="text-center p-4 shadow-sm border-0 bg-white">
                    <div className="display-1 text-success mb-2">✓</div>
                    <h5 className="fw-bold text-dark">Assinatura Concluída!</h5>
                    <p className="text-muted small">
                        O lançamento das suas férias foi confirmado e registrado com sucesso no sistema.
                    </p>
                </Card>
            </Container>
        );
    }

    return (
        <Container className="pt-4 px-3" style={{ maxWidth: "450px" }}>
            <Card className="shadow-sm border-0 p-3 bg-white">
                <h5 className="fw-bold text-primary mb-3 text-center">
                    🌴 Confirmação de Férias 
                </h5>

                <div className="bg-light p-3 rounded border mb-3 small">
                    <div className="mb-1">Colaborador: <strong>{nomeColaborador}</strong></div>
                    <div className="mb-1">Matrícula: <strong>{matriculaColaborador}</strong></div>
                    
                    {/* EXIBE O PERÍODO AQUISITIVO (Sem fechar o bloco se um deles faltar) */}
                    <div className="mb-1 text-muted">
                        Período Aquisitivo: <strong className="text-dark">
                            {periodoInicio || periodoFim ? `${periodoInicio || 'N/I'} a ${periodoFim || 'N/I'}` : 'Não informado'}
                        </strong>
                    </div>

                    <hr className="my-2" />
                    <div className="mb-1">Período de Gozo:</div>
                    <div className="fw-bold h6 text-success mb-1">
                        {dataInicio} até {dataFim}
                    </div>
                    <div>Total de Dias: <Badge bg="primary">{diasGozados} dias</Badge></div>
                </div>

                <Form onSubmit={handleAssinarFerias}>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Digite sua Senha para Assinar</Form.Label>
                        <Form.Control
                            type="password"
                            required
                            placeholder="Sua senha de acesso"
                            value={senha}
                            onChange={(e) => setSenha(e.target.value)}
                        />
                    </Form.Group>

                    <Button variant="success" type="submit" className="w-100 fw-bold" disabled={processando}>
                        {processando ? <Spinner animation="border" size="sm" /> : "Confirmar e Assinar Férias"}
                    </Button>
                </Form>
            </Card>
        </Container>
    );
}